export default __webpack_public_path__ + "static/media/web_screen_chat_de.cdb61027.png";